import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Crown, Check } from 'lucide-react';
export function FinalCTA() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-5 sm:px-6 bg-gradient-to-b from-black via-amber-950/20 to-black overflow-hidden" data-id="element-413" data-mp="c4ftoeizsnnn">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-900/10 via-black to-black" data-id="element-414" data-mp="m3dnnwz6t9e1" />

      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-415" data-mp="vui3t00ln0ag">
        <div className="mb-8 sm:mb-10 flex justify-center" data-id="element-416" data-mp="14w7we967w59t">
          <Crown className="w-12 h-12 sm:w-16 sm:h-16 text-amber-500" data-id="element-417" data-mp="zwmvht7hlmug" />
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-stone-100 mb-6 sm:mb-8 leading-tight" style={{
        fontFamily: 'Cinzel, serif',
        textShadow: '0 0 40px rgba(217, 119, 6, 0.4)'
      }} data-id="element-418" data-mp="2c4o9ar3rqx3k">
          Join The Private Research Order
        </h2>

        <p className="text-lg sm:text-xl md:text-2xl text-stone-300 mb-10 sm:mb-12 max-w-2xl mx-auto" data-id="element-419" data-mp="2m56y80a6x3sc">
          Join PSI PRO and unlock Peptide Mastery 2.0 one module at a time as
          part of your monthly membership.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-12 sm:mb-16" data-id="element-420" data-mp="301tyabxfwa2h">
          <div className="flex items-center gap-2 text-stone-400 text-sm sm:text-base" data-id="element-421" data-mp="34udfdivc5nc1">
            <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" data-id="element-422" data-mp="39sop7tlmrxu9" />
            <span data-id="element-423" data-mp="3errsb8i1vtzl">Cancel Anytime</span>
          </div>
          <div className="flex items-center gap-2 text-stone-400 text-sm sm:text-base" data-id="element-424" data-mp="3et2xncr599st">
            <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" data-id="element-425" data-mp="3itwlk64l6olp" />
            <span data-id="element-426" data-mp="1jnts5vleu1yv">Secure Payment</span>
          </div>
          <div className="flex items-center gap-2 text-stone-400 text-sm sm:text-base" data-id="element-427" data-mp="1jm8w21jg6ayw">
            <Check className="w-4 h-4 sm:w-5 sm:h-5 text-green-500" data-id="element-428" data-mp="1er3c389lv6dg" />
            <span data-id="element-429" data-mp="1showx2imdqdz">Lifetime Updates</span>
          </div>
        </div>

        <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" className="inline-block w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-black font-bold text-lg sm:text-xl rounded-lg shadow-[0_0_16px_rgba(217,119,6,0.28)] sm:shadow-[0_0_40px_rgba(217,119,6,0.4)] sm:hover:shadow-[0_0_60px_rgba(217,119,6,0.6)] sm:hover:scale-105 transition-all duration-300 min-h-[44px]" data-id="element-430" data-mp="1nq6wqgof7tu2">
          Join PSI PRO
        </a>

        <p className="mt-6 sm:mt-8 text-stone-500 text-sm sm:text-base" data-id="element-431" data-mp="h18gp6z8r5q2">
          $249/month — cancel anytime
        </p>
      </motion.div>
    </section>;
}